import { render, staticRenderFns } from "./CreateDamageModal.vue?vue&type=template&id=15530319"
import script from "./CreateDamageModal.vue?vue&type=script&lang=ts"
export * from "./CreateDamageModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports